import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth83: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M181,85.2l2.6,4.7v9.4s-1.6,4.3-1.6,4.3l-2.2,4.4c-98.5,12.8-155.2,1.8-155.2,1.8l-1.7-6.5.3-8.2,1.8-4,2.5-5.9c68,14.2,153.5,0,153.5,0h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M68.3,117.9h52.9c-33.4,71-52.9,0-52.9,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.1,122.1c-33.6-33.6,3.9-52.4,3.9-52.4l2.8,2.2,4,5.2,2.1,6.3,2.6,6.6v9.6s-1.6,4.1-1.6,4.1l-2.2,4.4-3.3,5.4-3.6,4.4-4.8,4.2h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.8,70.8c39.6,29-5.6,52.9-5.6,52.9l-3.9-5.6-3.6-8.3-1.7-6.5.3-8.3,4.3-9.8,2.3-3.8,3.3-5.2,4.5-5.4h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M182.5,92.7l.3,6.8-1.9,6.1-3.6,5.8-4,6.3-7.9,6.7-11.5,7.4-11.1,6.6-10.9,6.3-12.3,5.1-13.9,5.6-13.2,2.7h-16s-10.2-3.9-10.2-3.9l-6.9-4.6-7.3-2.9-6.9-6.6-7.6-8.7-8.8-11.6-3.9-8.9s-1.6-6.5-1.5-6.5v-9s1.4-2.8,1.4-2.8c96,32.9,158,0,158,0h-.3Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M182.6,92.6c-72.1,33.9-158,0-158,0v-2.2s1.8-3.3,1.8-3.3l2.3-5,2.8-4.9,3.1-4,5.4-5.3,4.7-5.2,5.2-4.3,7.1-4.4,8-4.9,7.6-4.5,6.1-3.2,8.5-3.2h16.7s5.5,1.5,5.5,1.5l5.9,1.6,8.9,3.3,8.8,5.6,4.4,1.8,8.7,4.1,8.5,4,9.3,5.2,7.3,3.5,5.1,3.3,3.9,5.1,1.4,7,1.2,8.4h-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.6,153l-16.6,3.8c-11.9,2.8-23.2-.4-32.7-7.1s-8.8-4.1-12.5-7.6-8.6-10.4-13.4-15.8c-8-9.2-13.3-21.4-9.8-33.9,7.2-25.5,32-38.4,54.2-50.5s34.3-3.1,47,4.1c7.3,4.2,14.4,7.3,21.9,11.1l23.1,11.8c9.8,5,10.5,15.4,12,26.9-2.5,13-10.4,23.6-21.7,30.3l-27.6,16.3-23.9,10.5Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '165.1 466.2 167.8 463.7 171.4 459.4 64.9 459.4 82.3 476.4 93.5 486.3 106.1 495.9 116.1 495.9 120.9 493.6 134.1 485.8 147 478 159.5 469.9 165.1 466.2',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M120.7,398.3A14.6,14.6 0 1 0 91.5,398.3A14.6,14.6 0 1 0 120.7,398.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.7,407.6h0c46.2.5,9.7,30.9,9.7,30.9l-5-7.1-4.2-8.2-.9-5.8.3-9.8h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M178.4,412.8h0c-50.4,16-1.3,34.4-1.3,34.4l.8-2.5,1.1-7.9.4-7.1v-7.9s-1-9.1-1-9.1h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M158.1,354.9c-55-30.9-111.7,0-111.7,0l-1.8,10.3c62-30.9,115.8,0,115.8,0,0,0-2.3-10.3-2.3-10.3Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M134.1,485.8h0c-9-64.9,27.8-113.1,27.8-113.1l4.4,9,5.3,11.3,4.5,11,2.3,8.7,1,9.1v7.9s-.4,7.9-.4,7.9l-1.1,7-.8,2.5-2.7,7-3,5.3-6.2,6.9-14.4,9.6-16.7,9.9h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.7,384.1h0c57.6,11.8,54.5,102,54.5,102l-9.8-8.7-18.5-18-6.8-7.4-6.4-7.1-5.4-6.3-4.9-6.9-4.3-8.4-.9-5.8-.7-5.6v-9s.3-6.9.3-6.9l1.1-6.2,1.8-5.7h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M44.5,365.4c62-31.2,115.8,0,115.8,0l1.7,7.4,4,8.8,3.8,8.1,4,8.9,3.8,10,2,12,.2,10.4-.5,6.5-.5,5.1-.9,2.6-1.8,6-2.6,5-2.8,4.5-3.3,3.9-4.6,4-13.7,8.3-14,8.8-12.1,7.2-5.4,2.7-6.4,1-5.8-1-7.6-5.9-5.8-5.1-8.1-6.7-7.5-7.2-11-10.6-8.1-8.2-6.5-7.5-5.2-5.2-4.8-7.4-3.6-7.9-1.7-9.4-.5-5.4,1-14.9,1.3-4.5,2.3-7.1,4-11,1-6.4v.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.5,479l-24.6,14.9c-6.3,3.8-13.4,2.8-18.9-2l-24.5-21.4c-11.6-10.2-21.7-21.5-31.4-33.4s-10.9-30.7-7.1-47c11.9-6.4,20.9-15.5,28.6-26.4s8.8-10.5,15.2-12.7,16.2-2.7,24.1-.5c12,3.3,24.3,7,34.4,14.4,5.2,3.9,8.2,10.6,12.1,15.8,7.5,10.1,14.7,19.6,24.4,27.7,4.7,20.8,4.1,44.3-12.1,58.4-5.9,5.1-13,8.2-20,12.4Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '156.8 33.2 113.5 7.6 111.7 7 107.3 6.2 104.2 6.7 100.3 7.8 94.6 11.4 65.6 39 161.6 39 156.8 33.2',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M68.7,86.5h60.1c-33.4,126.7-60.1,0-60.1,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.5,54.4c-64.7,13.3,2.6,35.1,2.6,35.1l.2-28.1-2.8-7.1h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.9,96l.4-7.4,2-8.2,4.3-9.2,10-12c40.2,19.3-16.7,36.8-16.7,36.8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M159.5,124.1l4.9-9.2,5.9-16.7.8-8.7.2-28.1-2.8-7.1-6.9-15.3-4.8-5.8-21.6-13.8c-6.9,75.9,24.3,104.7,24.3,104.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M75,30.1c2.1,68.8-39.8,93.5-39.8,93.5l-3.1-10.5s-1.3-9.2-1.2-9.2v-7.8s.4-7.4.4-7.4l1.8-8,4.5-9.5,10-12,18-20.2,9.4-9h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M156,130.5l-2.5,14.6c-61.5,54.2-113.8.4-113.8.4l-.9-7.6-.9-7.4c63.9,63.4,118.2,0,118.2,0h-.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M156.1,130.6c-60.7,65-118.2,0-118.2,0l-2.7-7.1-2.9-9.9-.2-.6s-1.3-9.2-1.2-9.2v-7s.4-8.2.4-8.2l2-8.2,4.3-9.2,9.5-11.5,18.4-20.7,29.1-27.6,5.7-3.6,3.4-1,3.6-.6,4.4.8,1.8.6,43.4,25.7,4.8,5.8,6.8,14.9,2.9,7.4-.2,28.3-.8,8.4-5.7,16.2-5.2,9.7-3.4,6.5h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M152.7,132.8c-19,26.9-47.3,52.1-78.9,33.2-17.5-10.5-32.2-30.4-40.8-48.9s-2.2-11.9-2.5-18c-.5-10.2,1.7-19.5,7.6-28,11.6-16.9,25.9-30.9,40.9-44.9S100.5,1.8,115.6,9.5c9.7,4.9,18.5,10.5,27.6,16.3s10.9,5.4,14.9,10.2c6.7,7.9,11.7,18.4,12.5,28.9,2.3,29-1.5,44.6-17.9,67.9Z',
			},
		},
	},
};
